/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Damages_DescriptionInputs */

const en_case_section_damages_description = /** @type {(inputs: Case_Section_Damages_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material damages, lost income, and other payable amounts.`)
};

const pt_br2_case_section_damages_description = /** @type {(inputs: Case_Section_Damages_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danos materiais, lucros cessantes e outros valores indenizáveis.`)
};

/**
* | output |
* | --- |
* | "Material damages, lost income, and other payable amounts." |
*
* @param {Case_Section_Damages_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_damages_description = /** @type {((inputs?: Case_Section_Damages_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Damages_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_damages_description(inputs)
	return pt_br2_case_section_damages_description(inputs)
});